import { useForm, type UseFormReturn } from 'react-hook-form';
import type { EditBankAddressFormValues } from './types';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import { editBankAddressFormSchema } from './validation';
import type { SavedBankAddress } from '@/entities/bank-address';

type Props = {
  savedBankAddress: SavedBankAddress;
};

type Params = {
  form: UseFormReturn<EditBankAddressFormValues>;
};

export const useEditBankAddressForm = ({ savedBankAddress }: Props): Params => {
  const { t } = useTranslation();

  const schema = editBankAddressFormSchema(t);

  const form = useForm<EditBankAddressFormValues>({
    mode: 'onSubmit',
    resolver: zodResolver(schema),
    defaultValues: {
      templateName: savedBankAddress.templateName,
    },
  });

  return {
    form,
  };
};
